export default "__VITE_ASSET__BrJDHq_2__"